import { render, staticRenderFns } from "./KaliteOnay.vue?vue&type=template&id=66eea70e"
import script from "./KaliteOnay.vue?vue&type=script&lang=js"
export * from "./KaliteOnay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports